interface CityValue {
  ms_city_name?: string | null;
  city_name?: string | null;
  name?: string | null;
}

interface LegacyLocationValue {
  city_name?: string | null;
  ms_city_name?: string | null;
  kota?: string | null;
}

export interface JobCitySource {
  city_name?: string | null;
  ms_city_name?: string | null;
  city?: CityValue | string | null;
  location?: LegacyLocationValue | null;
}

const cleanName = (value?: string | null) => value?.trim() || null;

export const getJobCityName = (job: JobCitySource): string | null => {
  const city = typeof job.city === 'string'
    ? cleanName(job.city)
    : cleanName(job.city?.ms_city_name)
      || cleanName(job.city?.city_name)
      || cleanName(job.city?.name);

  return cleanName(job.city_name)
    || cleanName(job.ms_city_name)
    || city
    || cleanName(job.location?.city_name)
    || cleanName(job.location?.ms_city_name)
    || cleanName(job.location?.kota);
};
